<div class="tbl-card">
    <div class="tbl-body">
        <div class="table-responsive">
            <p-table #d1 [value]="data" [alwaysShowPaginator]="false" [lazy]="tableConfig?.isLazy || false"
                [lazyLoadOnInit]="true" [paginator]="!tableConfig?.noPagination" (onLazyLoad)="loadData($event,d1)"
                [rows]="defaultRow" (onPage)="onPageChange($event)" [rowsPerPageOptions]="[10,20,50,100]" [autoLayout]="true" [totalRecords]="totalRecords" [globalFilterFields]="cols"
                [resizableColumns]="true" [first]="first" columnResizeMode="expand"
                [globalFilterFields]="globalFilterField" [responsive]="true" tableStyleClass="table width-full tbl-styled"
                [virtualScroll]="tableConfig?.virtualScroll || false" [scrollable]="tableConfig?.virtualScroll || false"
                [columns]="cols"
                [scrollHeight]="tableConfig?.scrollHeightPx ? ((data?.length *(tableConfig?.scrollHeightPx || 0)) > 1000 ? '1000px' : ((data?.length || 1) + 1) * (tableConfig?.scrollHeightPx || 100)+'px') :undefined"
                [virtualScrollItemSize]="tableConfig?.virtualScrollItemSize || 0">
                <ng-template pTemplate="caption">
                    <div class="d-flex flex-row justify-content-end">
                        <div class="tbl-global-search" *ngIf="tableConfig?.globalFilter">
                            <i class="pi pi-search tbl-search-icon"></i>
                            <input class="form-control tbl-search-input" placeholder="Search records..." pInputText type="text"
                                (input)="d1.filterGlobal($any($event.target).value, 'contains')">
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr class="tbl-header-row">
                        <th [hidden]="tableConfig?.hideSNo" class="sno-col">#</th>
                        <ng-container *ngFor="let col of cols; let i = index">
                            <th [pSortableColumn]="col.field" *ngIf="col.sort || col?.sort == undefined; else nonSort">
                                {{col.header | titleCaseExtend | translate}}
                                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <ng-template #nonSort>
                                <th> {{col.header | titleCaseExtend |translate}}</th>
                            </ng-template>
                        </ng-container>
                        <th *ngIf="actionBtn?.length" class="action-header">
                            <span class="action-label">{{'Actions' | translate}} </span>
                            <div class="action-header-btns">
                                <button type="button" (click)="reload()" class="btn btn-sm btn-outline-light tbl-icon-btn"
                                    title="Reload Table" [disabled]="tableLoader">
                                    <i class="pi" [ngClass]="tableLoader ? 'pi-spin pi-spinner' : 'pi-refresh'"></i>
                                </button>
                                <button *ngIf="tableConfig?.addBtn" type="button" (click)="btnAction('','ADD',{})"
                                    class="btn btn-sm btn-light tbl-icon-btn" title="Add New" [disabled]="tableLoader">
                                    <i class="pi pi-plus"></i>
                                </button>
                                <button *ngIf="tableConfig?.exportBtn" type="button" (click)="btnAction('','EXPORT')"
                                    class="btn btn-sm btn-success tbl-icon-btn" title="Export to Excel"
                                    [disabled]="exportLoading || tableLoader">
                                    <i class="pi pi-file-excel"
                                        [ngClass]="{'pi-spin pi-spinner': exportLoading || tableLoader}"></i>
                                </button>
                            </div>
                        </th>
                    </tr>
                    <tr class="tbl-filter-row" *ngIf="tableConfig?.showFilter == undefined ||tableConfig?.showFilter">
                        <th [hidden]="tableConfig?.hideSNo"></th>
                        <ng-container *ngFor="let c of cols;">
                            <th *ngIf="c?.filter === true || c?.filter == undefined; else nonFilter">
                                <ng-container *ngIf="c?.filterCol?.type == 'TEXT' || !c?.filterCol?.type">
                                    <p-columnFilter type="text" placeholder="search" matchMode="contains"
                                        [showMenu]="false" [field]="c?.field"></p-columnFilter>
                                </ng-container>
                                <ng-container *ngIf="c?.filterCol?.type == 'DROPDOWN'">
                                    <p-columnFilter [field]="c?.colName" matchMode="equals" [showMenu]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown [appendTo]="'body'" [baseZIndex]="10000" [ngModel]="value"
                                                [filter]="FORM_SUPPORT_DATA[c?.colName]?.length > 15 ? true : false"
                                                (onChange)="filter($event.value)"
                                                [options]="FORM_SUPPORT_DATA[c?.colName]"
                                                [optionValue]="c?.filterCol?.selectPrimaryKey ||  'key'"
                                                [placeholder]="c?.filterCol?.placeholder || 'Any'"
                                                [optionLabel]="c?.filterCol?.selectKeyName || 'label'"
                                                [showClear]="true">
                                                <ng-template let-option pTemplate="item">
                                                    <span class="customer-badge status"
                                                        *ngIf="DATA_LOADING[c?.colName]">{{ 'loading...' }}</span>
                                                    <span
                                                        class="customer-badge status">{{option[c?.filterCol?.selectKeyName
                                                        || 'label']}}</span>
                                                </ng-template>
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>
                                </ng-container>
                                <ng-container *ngIf="c?.filterCol?.type == 'DATE'">
                                    <p-columnFilter [field]="c?.field" matchMode="equals" [showMenu]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-calendar [readonlyInput]="true" dateFormat="dd/mm/yy"
                                                [showButtonBar]="true" appendTo="body"
                                                [view]="c?.filterCol?.dateViewMode || 'date'"
                                                (onSelect)="filter($event)" (onClearClick)="filter($event)"
                                                [maxDate]="c?.filterCol?.maxDate"
                                                [monthNavigator]="c?.filterCol?.monthNavigator ?true : false"
                                                [yearNavigator]="c?.filterCol?.yearNavigator ? true : false"
                                                [minDate]="c?.filterCol?.minDate"
                                                [yearRange]="c?.filterCol?.yearRange || yearRange"
                                                [placeholder]="c?.filterCol?.placeholder || 'Any'">
                                            </p-calendar>
                                        </ng-template>
                                    </p-columnFilter>
                                </ng-container>
                            </th>
                            <ng-template #nonFilter>
                                <th></th>
                            </ng-template>
                        </ng-container>
                        <th *ngIf="actionBtn?.length"></th>
                    </tr>
                    <tr *ngIf="tableLoader" class="tbl-loading-row">
                        <td [attr.colspan]="(cols.length+1) + (actionBtn?.length || 0)" class="p-0">
                            <div class="tbl-loading-bar">
                                <div class="tbl-loading-bar-inner"></div>
                            </div>
                            <div class="tbl-loading-text">
                                <i class="pi pi-spin pi-spinner mr-1"></i>Loading data, please wait...
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="(cols.length+1) + (actionBtn?.length || 0)" class="tbl-empty">
                            <i class="pi pi-inbox tbl-empty-icon"></i>
                            <div class="tbl-empty-text">No records found</div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-request let-i="rowIndex">
                    <tr (click)="onSelectData(request)"
                        [ngClass]="{'bg-primary text-light selectedRow' : request.selectable,'cursor-pointer' : request.selectable}"
                        class="tbl-body-row {{request.selectable ? 'cursor-pointer bg-primary text-light' : request.classList ? request.classList : '' }}">
                        <td [hidden]="tableConfig?.hideSNo" class="sno-cell">{{i + 1}}</td>
                        <ng-container *ngFor="let col of cols;">
                            <td>
                                <ng-container *ngFor="let a of getColWithJoin(col.colName);index as ind">
                                    <ng-container [ngTemplateOutlet]="rowTable"
                                        [ngTemplateOutletContext]="{request:request,i:i,col:a}">
                                    </ng-container>
                                    <ng-template #rowTable let-request="request" let-i="i" let-col="col">

                                        <ng-container *ngIf="!col?.isEditable;">
                                            <ng-container [ngSwitch]="col?.type">
                                                <ng-container *ngSwitchCase="'IMAGE'">
                                                    <img imageLoad [src]="request[col.field]"
                                                        class="mr-1 w35 h35 rounded-circle border">
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'DATE'">
                                                    {{request[col.field]?.date || request[col.field] |
                                                    dateFormat:'dd-MM-yyyy'}}</ng-container>
                                                <ng-container *ngSwitchCase="'DATETIME'">
                                                    {{request[col.field]?.date || request[col.field] |
                                                    dateFormat:'dd-MM-yyyy h:mm a'}}</ng-container>
                                                <ng-container *ngSwitchCase="'CURRENCY'">{{request[col.field] |
                                                    currencyFormat}}</ng-container>
                                                <ng-container *ngSwitchCase="'STATUS'">
                                                    <span class="badge badge-pill"
                                                        [ngClass]="{'badge-success' : +request[col.field]==1 , 'badge-danger' : +request[col.field] ==0, 'badge-warning' : +request[col.field] == 2 }">{{statusArray[request[col.field]]}}</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'DROPDOWN'">
                                                    <ng-container
                                                        *ngIf="FORM_SUPPORT_DATA[col?.colName] | filter : col?.filterCol?.selectPrimaryKey || 'key' : request[col.colName]; let m">
                                                        <span *ngIf="m?.color;"
                                                            class="badge badge-pill badge-{{m?.color || 'info'}}">{{
                                                            m[col?.filterCol?.selectKeyName || 'label']}}</span>
                                                        <span *ngIf="!m.color;">{{m[col?.filterCol?.selectKeyName ||
                                                            'label']}}</span>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container
                                                    *ngSwitchCase="['STAFF_EMP_ID','CHILD_ID','SPONSOR_ID','PROMOTIONAL_ID','CHURCH_ID'].includes(col.type) ? col.type : false">
                                                    <ng-container
                                                        *ngFor="let f of request[col.field] | transformArray:',':' & '">
                                                        <strong><a title="Info"
                                                                (click)="openStaffInfo(f,col.type,request)"
                                                                href="javascript:void(0)">{{f}}</a></strong>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'VIEW_INFO'">
                                                    <ng-container
                                                        *ngFor="let f of request[col.field] | transformArray:',':' & '">
                                                        <strong><a title="View Info"
                                                                (click)="btnAnchorAction(f,request,col?.colName)"
                                                                href="javascript:void(0)"
                                                                [innerHTML]="f |safeHtml"></a></strong>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'VIEW_TAG_INFO'"
                                                    style="white-space: normal; min-width: 100px;max-width:30vw;">
                                                    <ng-container *ngFor="let f of request[col.field]">
                                                        <span class="cursor-pointer" (click)="btnTagInfo(f,request)"
                                                            [innerHTML]="f?.text |safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <span
                                                        *ngIf="col?.icon_append?.text && request[col.field] ; else noAppend"
                                                        [innerHTML]="request[col.field] + ' ' +col?.icon_append?.text || '' | safeHtml"></span>
                                                    <ng-template #noAppend><span
                                                            [innerHTML]="request[col.field] || '' | safeHtml"></span></ng-template>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>

                                        <ng-container *ngIf="col?.isEditable">
                                            <div style="min-height: 30px;" pEditableColumn="request[col.field]">
                                                <p-cellEditor>
                                                    <ng-template pTemplate="input">
                                                        <input pInputText type="text"
                                                            (keydown.enter)="updateRow(request,col?.field,request[col.field],i)"
                                                            (change)="updateRow(request,col?.field,request[col.field],i)"
                                                            class="w-100" [(ngModel)]="request[col.field]" required>
                                                    </ng-template>
                                                    <ng-template pTemplate="output">
                                                        <span style="min-width:20px"
                                                            (click)="onclickSpan($event)">{{request[col.field]}}</span>
                                                    </ng-template>
                                                </p-cellEditor>
                                            </div>
                                        </ng-container>
                                    </ng-template>
                                    <span *ngIf="ind == 0 && col?.colJoinSeparator" [innerHTML]="col.colJoinSeparator =='next_line' ? '<br>' :
                                        col.colJoinSeparator || '&nbsp;'"></span>
                                </ng-container>
                            </td>
                        </ng-container>


                        <td *ngIf="actionBtn?.length && makeChange" class="action-col">
                            <ng-container *ngFor="let b of actionBtn">
                                <ng-container [ngSwitch]="b?.category">
                                    <ng-container *ngSwitchCase="'TEXT'">
                                        <span
                                            *ngIf="!b.condition || (b.condition && (request | conditionOperator : b.condition))">{{b.name}}</span>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <button [disabled]="btnLoader[i + b?.type] || false"
                                            *ngIf="!b.condition || (b.condition && (request | conditionOperator : b.condition))"
                                            class="btn btn-sm ml-1 {{b.class || ''}}" [class.btn-outline-secondary]="!b.class"
                                            [title]="b?.title | titlecase"
                                            (click)="$event.stopPropagation();btnAction(request[primaryKey] || '', b?.type,request,i)">
                                            <i *ngIf="btnLoader?.[i + b?.type]" class="pi pi-spin pi-spinner"></i>
                                            <i *ngIf="(!btnLoader[i + b?.type])"
                                                class="{{b.iconClass || ''}} {{b.icon}}"></i>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft" let-state>
                    <span class="tbl-paginator-info">
                        Showing <strong>{{ state.first ? state.first+1 :1}}</strong> –
                        <strong>{{ (state.first+state.rows) > state.totalRecords ?
                        state.totalRecords : state.rows+state.first }}</strong>
                        of <strong>{{state.totalRecords}}</strong> records
                    </span>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>